// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 951) return "static/css/951.48fd99788df4933b20b8.lib.css";
	if (chunkId === 853) return "static/css/853.e2a4f04e0f912dadb6e4.css";
	// return url for filenames based on template
	return undefined;
};